import { User } from 'src/app/_models/User';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PreloaderService } from 'src/app/_services/Preloader.service';
import { _userServicesService } from 'src/app/_services/_UserService/_userServices.service';
import { ToasterService } from 'src/app/_services/Toaster.service';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-EditUser',
  templateUrl: './EditUser.component.html',
  styleUrls: ['./EditUser.component.scss']
})
export class EditUserComponent implements OnInit {

  @Input() DeviceIDFromHome: any;
  @Input() User: User;
  @Input() UserID:any;
  @Input() UserIDFromHome: any;
  @Output() cancelEditUser = new EventEmitter();
  model:any={};
  LastUserIndex: string;

  selectedCheckbox:any;

  constructor(private spinner:NgxSpinnerService, private preloader: PreloaderService,private UserService: _userServicesService, private notiService: ToasterService) { }

  ngOnInit() {
this.model.username=this.User.username;
this.model.userID=this.User.userID;
console.log(this.User.userID);
console.log(this.model.userID);

this.model.user_Privilege=this.User.user_Privilege;

}
  selectChangeHandler(event: any) {
    this.selectedCheckbox = event.target.value;
  }
  CancelEditUser() {
    this.cancelEditUser.emit(false);
  }

  AddUser() {
    if (this.DeviceIDFromHome == null || this.DeviceIDFromHome == "") {
      return this.notiService.error("Error", "Select Device First")
    }
    if (this.DeviceIDFromHome == "Select Device" ) {
      return this.notiService.error("Error", "Select Device First")
    }
    if(this.User.userID==undefined)
    {
      return this.notiService.error("Error","User ID not defined");
    }
    if(this.User.username==undefined)
    {
      return this.notiService.error("Error","User name not defined");
    }
    if(this.selectedCheckbox==undefined)
    {

      return this.notiService.error("Error","Enroll  not defined");
    }
    this.spinner.show();
    this.model.Mode=this.selectedCheckbox;
    this.model.Priviledge=this.model.user_Privilege;


    this.model.DevID = this.DeviceIDFromHome;
    this.UserService.EditUser(this.model).subscribe(Response => {
      this.spinner.hide();
     if(Response.status==200)
     {
      this.notiService.success('Success', Response.body);

     }
     else
     {
      this.notiService.error('Error', Response.body);

     }
    }, error => {
      this.spinner.hide();
      if(error.status==400)
      {
        this.notiService.error('Error', error.error);
      }
      else
      {
       this.notiService.error('Something Went Wrong', error);
      }

    });
  }


}
